import React, { Fragment, useState, useEffect } from 'react'
import { useSelector } from "react-redux";
import { setUserEntry, LogOut, updateStationId } from "../../server/Customer";
import {  globalFileIcon } from '../../../axiosInstance';
import { useDispatch } from 'react-redux';
import { NavLink, useNavigate } from "react-router-dom";
import Accessibility from '../Accessibility'
import CustomerService from '../customerService/CustomerService';
import PrivateAreaList from '../privateArea/PrivateAreaList';
import { setToggleCart } from "../../server/CartsOpen";
import { FiArrowLeft } from 'react-icons/fi';
import { GetStation, GetStationsToUser } from "../../server/Station";

const HeaderConnection = ({ user, stationId, role}) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [openMenu, setOpenMenu] = useState(false);
    const [openPrivateAreaList, setOpenPrivateAreaList] = useState(false);
    const [userStation, setUserStation] = useState(null);
    const [adminStation, setAdminStation] = useState([]);
    const selectStation = useSelector(state => state.user.stationId);
    
    const handleNavigation = () => {
        dispatch(setToggleCart(false));
        navigate('/about');
    };

    const exit = () => {
        navigate('/');
        dispatch(LogOut())
    }

    const check = (stationId) => {    
        const newStationId = stationId;
        dispatch(updateStationId(newStationId));
        user.StationId = newStationId;
    }   
    
    useEffect(() => {
        console.log("in header:",role, selectStation);
        
        if(role){
            GetStationsToUser(user?.Id).then((x) => {
                setAdminStation(x.data);
            });
        }
        else{
            GetStation(selectStation).then((x) => setUserStation(x.data));
        }
    }, [user, stationId, selectStation])
    
    return (
        <div className='header-connection'>
            <NavLink to="/" className='site-icon'><img  loading="lazy" src={globalFileIcon + 'site-icon.svg'} alt="site" /></NavLink>
            <div className='header-data'>

                <li className="data" onClick={handleNavigation}>
                    <img loading="lazy" src={globalFileIcon + 'about.svg'} alt="about" />
                   <span className="about">אודות</span>
                </li>
                <li className={openMenu? "data open-menu":"data" } onClick={() => setOpenMenu(true)} >
                    <img  loading="lazy" src={globalFileIcon + 'customer-service.svg'} alt="customer-service" />
                    <a className='customer-service'>שירות לקוחות</a>
                </li>
                {openMenu ? <div className='customer-service-menu'><CustomerService setOpenMenu={setOpenMenu} /></div> : null}
                <Accessibility />
            </div>
            <div className="login-or-sign-in">
                {!user ? (
                    <div>
                        <button className="login" onClick={() => dispatch(setUserEntry([true, "login"]))}>
                            כניסה
                        </button>
                        <button className="sign-in" onClick={() => dispatch(setUserEntry([true, "signIn"]))}>
                            הרשמה
                        </button>
                    </div>
                ) : (
                    <Fragment>
                        <div>
                            {role ? (
                                <button className="btn-to-private-area station-user">
                                        הינך נכנס כמנהל לתחנת{" "}
                                    <select onChange={(e) => check(e.target.value)} className="custom-select">
                                        {adminStation.map((station) => (
                                            <option key={station.Id} value={station.Id}>
                                                {station.Name}
                                            </option>
                                        ))}
                                    </select>
                                </button>
                            ) : (
                                <button className="btn-to-private-area station-user">
                                    <span className="custom-customer">תחנת{" "}{userStation?.Name}</span>
                                </button>
                            )}
                            {!user.UserTypeId ? (
                                <Fragment>
                                    <button onClick={() => setOpenPrivateAreaList(true)} className="btn-to-private-area">
                                        <span>לאזור האישי של {user.Name} {user.LastName}</span>
                                    </button>
                                    {openPrivateAreaList ? (
                                        <div className='private-area-list-menu'>
                                            <PrivateAreaList setOpenPrivateAreaList={setOpenPrivateAreaList} />
                                        </div>
                                    ) : null}
                                </Fragment>
                            ) : null}

                            <button onClick={exit} className="exit">
                                <span>יציאה</span>
                            </button>
                            <button onClick={()=>navigate(-1)} className="exit">
                                <FiArrowLeft />
                            </button>
                        </div>
                                
                    </Fragment>
                )}
            </div>

        </div>
    )
}

export default HeaderConnection
